import React from "react";
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { msalConfig } from "./authConfig";
import { I18nProvider } from "./i18n";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  const container = document.getElementById('root');
  const root = createRoot(container);

  root.render(
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <I18nProvider>
          <App />
        </I18nProvider>
      </MsalProvider>
    </ErrorBoundary>
  );
}).catch(error => {
  console.error("MSAL init failed:", error);
});